import { render, staticRenderFns } from "./TopPageStudyCategory.vue?vue&type=template&id=16728e14&scoped=true&lang=pug&"
import script from "./TopPageStudyCategory.vue?vue&type=script&lang=ts&"
export * from "./TopPageStudyCategory.vue?vue&type=script&lang=ts&"
import style0 from "./TopPageStudyCategory.vue?vue&type=style&index=0&id=16728e14&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16728e14",
  null
  
)

export default component.exports